import { PLURALL_VARIABLE_SEED_COLORS } from "../../consts";
import {
  generatePaletteFromSeedColors,
  generateSeedColorsFromVariableSeedColors
} from "../../utils";

export const plurallSeedColors = generateSeedColorsFromVariableSeedColors(
  PLURALL_VARIABLE_SEED_COLORS
);

export const plurallPalette = generatePaletteFromSeedColors(plurallSeedColors);
